import { DROPDOWN_PAGE, panelDelete, panelGet, panelPost, panelPut } from "./panel.api";
import { TemplatePayload } from "./types";

/**
 * template — /template
 *
 * These are the e-mail templates (subject/message per lifecycle event, plus
 * reminder and expiry rules), not the document templates in Manage Catalog.
 */
export const templateApi = {
  getAll: () => panelGet<TemplatePayload[]>("/template", DROPDOWN_PAGE),
  getById: (id: string) => panelGet<TemplatePayload>(`/template/${id}`),
  create: (payload: TemplatePayload) => panelPost<TemplatePayload>("/template", payload),
  update: (id: string, payload: TemplatePayload) => panelPut<TemplatePayload>(`/template/${id}`, payload),
  remove: (id: string) => panelDelete(`/template/${id}`),
};
